import gql from 'graphql-tag'

export const UPDATE_ADVISORY_VALUE = gql`
mutation UpdateAdvisoryValue($data: [updateAdvisoryValueData]!, $dateForAdvisory: String, $source: String) {
  updateAdvisoryValue(data: $data, DateForAdvisory: $dateForAdvisory, source: $source)
}`

export const UPDATE_ADVISORY_STATUS = gql`
  mutation updateAdvisoryStatus($data: [updateAdvisoryStatusData]!) {
    updateAdvisoryStatus(data: $data)
  }
`
